import { publicEnv } from "@/config/env";
import CourseDetails from "@/features/courses/components/course-details";
import { NotFoundPage } from "@/features/shared/components/not-found-page";
import { appDetailTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/courses/$id")({
  head: () => appDetailTitleHead("courses"),
  component: CourseDetailPage
});

function CourseDetailPage() {
  if (publicEnv.USE_BOOKING === "false") {
    return <NotFoundPage />;
  }

  return (
    <div className="w-full">
      <CourseDetails />
    </div>
  );
}
